import React from "react";
import moment from "moment";
import { get, isEmpty } from "lodash";
import { Button, IconButton } from "@mui/material";

import DialogNoti from "../DialogNoti";
import DialogNote from "./dialogNote";
import styleStatus from "./styleds";
import AddIcon from "../../../../../../assets/health/add-icon.svg";
import AttatchIcon from "../../../../../../assets/health/attatch-icon.svg";
import { getStatusById } from "../../utils";

export default function Approve(props) {
  const users = JSON.parse(localStorage.getItem("user")) || {};
  const { state, dispatch, level_id } = props;
  const classes = styleStatus();
  const privilegesFromUser =
    get(users, "role_management_claim.privileges") || {};

  const {
    detail,
    dialogNoti,
    listNote,
    currentFilePdf,
    tabButton,
    rowsHistoryTable1,
  } = state;
  const { elements = [] } = detail;

  const getComment = (item) => {
    const data_element_note = detail?.elements?.filter(
      (i) =>
        i.type_id === 520 &&
        i.status_id != 2 &&
        get(i, "extra_info.documents[0].path") ===
          get(item, "extra_info.documents[0].path")
    );
    return (data_element_note || []).reverse();
  };

  return (
    <>
      <div className={classes.containerStatus}>
        <div className={classes.row}>
          <div className="box-button">
            <Button
              onClick={() =>
                dispatch({ type: "changeButtonTabs", name: "new-approve" })
              }
              className={
                tabButton === "new-approve"
                  ? "button btn-new btn-active"
                  : "button btn-new"
              }
              variant="outlined"
            >
              Mới
            </Button>
            <Button
              onClick={() =>
                dispatch({ type: "changeButtonTabs", name: "approved" })
              }
              className={
                tabButton === "approved"
                  ? "button btn-approve btn-active"
                  : "button btn-approve"
              }
              variant="outlined"
            >
              Đã duyệt
            </Button>
          </div>
          <div
            className={classes.boxAdd}
            onClick={() =>
              dispatch({ type: "openDialogNote", name: "addNote" })
            }
          >
            <img src={AddIcon} alt="add-icon" className="icon color" />
            <span className="color">Thêm ghi chú</span>
          </div>
        </div>
        {!isEmpty(currentFilePdf) && tabButton == "new-approve" && (
          <div className={classes.box}>
            <div className="bold">Yêu cầu duyệt</div>
            <div className="gray">
              {moment(currentFilePdf?.data_element?.created_date).format(
                "HH:mm DD/MM/YYYY"
              )}
            </div>
            <div>{`Hồ sơ số ${detail?.code || ""}  chờ phê duyệt`}</div>
            {(currentFilePdf?.data_element_note || []).map((item, key) =>
              item?.text ? (
                <div className="gray spacing" key={`not-elements-${key}`}>
                  {`${item?.extra_info?.user?.userNote?.fullname || ""}:`}{" "}
                  <span className="color"> {item?.text || ""}</span>
                </div>
              ) : null
            )}
            <div className={classes.row}>
              <div>
                <IconButton
                  style={{ padding: "4px" }}
                  onClick={() => {
                    window.open(currentFilePdf?.path);
                  }}
                >
                  <img src={AttatchIcon} alt="attatch" className="icon color" />
                </IconButton>
                1
              </div>
              {(level_id == 2 &&
                currentFilePdf?.data_element?.status_id == 2) ||
              (level_id == 1 && currentFilePdf?.data_element?.status_id == 3) ||
              privilegesFromUser?.CLAIM_APPROVE != 1 ? (
                <></>
              ) : [4, 5, 6, 7, 8, 9, 10].includes(
                  +(currentFilePdf?.data_element?.status_id || 0)
                ) ? (
                <div
                  style={{
                    color: getStatusById(
                      currentFilePdf?.data_element?.status_id
                    ).color,
                  }}
                >
                  {getStatusById(currentFilePdf?.data_element?.status_id).label}
                </div>
              ) : (
                <div>
                  {level_id !== 1 && (
                    <Button
                      className={
                        users?.id != detail?.userIdAssign
                          ? "refuse refuse-disabled"
                          : "refuse"
                      }
                      disabled={users?.id != detail?.userIdAssign}
                      variant="outlined"
                      onClick={() =>
                        dispatch({
                          type: "openDialogNote",
                          name: "submitRefuse",
                        })
                      }
                    >
                      Từ chối
                    </Button>
                  )}
                  <Button
                    className={
                      level_id != 1 && users?.id != detail?.userIdAssign
                        ? "agree agree-disabled"
                        : "agree"
                    }
                    variant="contained"
                    disabled={
                      level_id != 1 && users?.id != detail?.userIdAssign
                    }
                    onClick={() =>
                      dispatch({
                        type: "openDialogNote",
                        name:
                          level_id == 1
                            ? "sendRequestApprpve"
                            : "submitApprove",
                      })
                    }
                  >
                    {level_id == 1 ? "Gửi yêu cầu" : "Phê duyệt"}
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}

        {tabButton == "approved" &&
          rowsHistoryTable1?.map((item, index) =>
            [5, 6, 7, 8].includes(item?.status_id) ? (
              <div className={classes.box} key={`approve-${index}`}>
                <div className="bold">Yêu cầu duyệt</div>
                <div className="gray">
                  {moment(currentFilePdf?.data_element?.created_date).format(
                    "HH:mm DD/MM/YYYY"
                  )}
                </div>
                <div>{`Hồ sơ số ${detail?.code || ""}  chờ phê duyệt`}</div>
                {(getComment(item) || []).map((itemComment, key) =>
                  !!itemComment?.text ? (
                    <div className="gray spacing" key={`not-elements-${key}`}>
                      {`${
                        itemComment?.extra_info?.user?.userNote?.fullname || ""
                      }:`}{" "}
                      <span className="color"> {itemComment?.text || ""}</span>
                    </div>
                  ) : null
                )}
                <div className={classes.row}>
                  <div>
                    <IconButton
                      style={{ padding: "4px" }}
                      onClick={() => {
                        window.open(get(item, "extra_info.documents[0].path"));
                      }}
                    >
                      <img
                        src={AttatchIcon}
                        alt="attatch"
                        className="icon color"
                      />
                    </IconButton>
                    1
                  </div>

                  <div
                    style={{
                      color: getStatusById(item?.status_id).color,
                    }}
                  >
                    {getStatusById(item?.status_id).label}
                  </div>
                </div>
              </div>
            ) : null
          )}
        {listNote.map((item, index) => (
          <div className={classes.box} key={`note_coment_${index}`}>
            <div className="bold">Ghi chú</div>
            <div className="gray">
              {moment(item?.created_date).format("HH:mm, DD/MM/YYYY")}
            </div>
            {item.type_id == 520 ? (
              <div className="gray">{`Bởi Khách hàng`}</div>
            ) : (
              <div className="gray">{`Bởi ${
                item?.extra_info?.user?.userNote?.fullname || ""
              } (cấp ${
                item?.extra_info?.user?.userNote?.level_id || ""
              })`}</div>
            )}
            <div className="color">{item?.text || ""}</div>
          </div>
        ))}
        <DialogNote {...{ state, dispatch, level_id }} />
        <DialogNoti {...{ state, dispatch, data: dialogNoti }} />
      </div>
    </>
  );
}
